import { Injectable, EventEmitter } from '@angular/core';
import { AuthService } from '@auth/auth.service';
import { defaultPage } from '@documalis/_const/const';
import { RightService } from '@service/right.service';
import { MessagesService } from './messages.service';
import { customizedScreenRoutes } from '@custom/custom.route';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';
import {LayoutService} from "../../layout/service/app.layout.service";
import { ApiV6Service } from '@service/apiv6.service';
import { findItem } from '../_utils/tools.utils';
import { MsalService } from '@azure/msal-angular';

@Injectable()
export class MenuServiceInt {
    public menuMode: string = '';
    public dark = true;
    public reset: boolean;
    public menuTheme: string = '';
    public topBarTheme: string = '';

    public display = false;
    public items = [];
    public itemsAccess = [];
    public currentTheme: string = '';
    public loaded = false;
    public items$ = new EventEmitter();
    private _menuVisible: boolean;
    public _menuRestrict: boolean;

    private logoutMenu: any;
    private customMenu = [];
    private editorUpdate: boolean = false;
    public delegateEnable: boolean = false;
    public userName: string = '';
    public allowRequest: boolean = false;
    public allowFullText: boolean = false;
    public allowSearchIdx: boolean = false;
    public _menuUserRole: boolean;
    private userRoleMenuData: any;

    constructor(
        private api: ApiV6Service,
        public auth: AuthService,
        private rightService: RightService,
        protected _messageService: MessagesService,
        private layoutService : LayoutService,
        private translate: TranslateService,
        private authService: MsalService,
    ) {
        let wResult: any;
        this.loaded = false;
        this._menuRestrict = false;
        this._menuUserRole = false;
        this.menuMode = this.layoutService.config().menuMode;
        this.menuTheme = this.layoutService.config().menuTheme;
        this.topBarTheme = this.layoutService.config().topbarTheme;
        this.logoutMenu = [
            {
                id: 'Logout',
                styleClass: 'Logout',
                label: this.translate.instant('DisConnect'),
                icon: 'pi pi-sign-out',
                command: (event) => {
                    this.logout();
                },
                routerLink: ['/login'],
                forceRoot: true,
            },
        ];
        this.auth.isAuthenticated().then(
            wRes => {
                if (wRes) {
                    wResult = this.setMenuItem();
                    if (wResult === false) {
                        this.logout();
                    }
                }
            }
        );
    }

    public async getMenu(): Promise<boolean> {
        let result: boolean;
        try {
            result = await this.setMenuItem();
        } catch (error) {
            return false;
        }
        return result;
    }

    public async setMenuItem() {
        let wResAccess: any;
        let wRole = false;
        wRole = this.auth.isAdmin();
        try {
            wResAccess = await lastValueFrom(this.api.execUrlAction('setaccess', ''));
        } catch (error) {
            this._messageService.addErrorMsg(
                this.translate.instant('Get_Rght_KO'), this.translate.instant('Com_KO'));
            this.logout();
            return false;
        }

        try {
            this.rightService.setRight(wResAccess.rights);
            this.addCustomMenu(wResAccess.custommenu, wResAccess.customrights);
            this.editorUpdate = wResAccess.dataeditorupdate;
            this.delegateEnable = wResAccess.datadelegateenable;
            this.userRoleMenuData = wResAccess.datauserrolemenudata;

            this.rightService.updateMenu(wResAccess.allowSearch, wResAccess.allowBasket, wResAccess.allowPref);
            this.rightService.getDisplayAction(wRole);
            this.items = this.setMenu(wRole, this.customMenu);
            this.itemsAccess = JSON.parse(JSON.stringify(this.getAccessList(wRole)));
            this.setRestricted();
            this.allowRequest = this.getAllowRequest();
            this.allowFullText = this.getAllowSearchFullText();
            this.allowSearchIdx = this.getAllowSearchIdx();
            this.loaded = true;
            this.menuVisible = true;
            if (this.auth.getApi() === true) {
                this.forceRestricted();
            }
            this.items$.emit(this.items);
            return true;
        } catch (error) {
            this._messageService.addErrorMsg(
                this.translate.instant('Get_Rght_KO'), this.translate.instant('Com_KO'));
            this.logout();
        }
        return false;
    }

    public setLogoutMenu(aMsg) {
        this.logoutMenu[0].label = aMsg;
    }

    public setRestricted() {
        if (this.menuRestrict === true) {
            this.forceRestricted();
        }
    }

    private forceRestricted() {
        this.items = this.items.filter(item => {
            return item.id === 'Logout';
        })
    }

    public updateRestrited(aRestricted) {
        this.menuRestrict = aRestricted;
        this.setRestricted();        
        this.items$.emit(this.items);
    }

    private getAccessList(aRole: boolean) {
        return [
            ...this.items,
            ...this.getAdminMenuElem(aRole),
        ];
    }

    private getPageList(aItems, aPage) {
        if (Array.isArray(aItems)) {
            aItems.map((item) => {
                if (Array.isArray(item.items)) {
                    this.getPageList(item.items, aPage)
                } else {
                    if (item.routerLink !== undefined) {
                        aPage.push(item.routerLink[0])
                    }
                }
            })
        } else {
            if (aItems.routerLink !== undefined) {
                aPage.push(aItems.routerLink[0])
            }
        }        
    }

    // Ajout des écrans personnalisés
    private addCustomMenu(wCustMenuBaselist, wCustomRights) {
        let wSubMenu = [];
        this.customMenu = [];
        wCustMenuBaselist.forEach((item) => {
            wSubMenu = this.getSubMenu(item.menuitem, wCustomRights);
            if (wSubMenu.length > 1) {
                this.customMenu.push({
                    id: item.name + item.id,
                    label: item.label,
                    icon: 'pi pi-fw pi-id-card',
                    items: wSubMenu,
                    forceRoot: false,
                });
            } else if (wSubMenu.length === 1) {
                this.customMenu.push(wSubMenu[0]);
            }
        });       
    }

    private getSubMenu(aMenuItem, aCustomRights) {
        let wIndex = -1;
        let wSubMenu = [];
        let wMenuItem = JSON.parse(aMenuItem);
        wMenuItem.forEach(item => {
            wIndex = findItem(aCustomRights, item.value, 'name');
            if (wIndex !== -1) {
                wSubMenu.push({ label: aCustomRights[wIndex].label, icon: 'pi pi-fw pi-id-card', routerLink: ['/' + aCustomRights[wIndex].name] });
            }
        });        
        return wSubMenu;
    }

    private setMenu(aRole, aCustomMenu) {
        return [
            ...this.rightService.getBskMenu(),
            ...this.rightService.getSearchMenu(),
            ...this.defaultMenu(aRole, aCustomMenu),
        ];
    }

    private defaultMenu(aRole, aCustomMenu) {
        return [...aCustomMenu,...this.getPrefMenu(aRole),...this.getAdminMenu(aRole),...this.logoutMenu];
    }

    private getPrefMenu(aRole) {
        let wPrefMenu = [];
        let wItemsPref = [];
        wItemsPref = this.rightService.getToolsMenu(aRole);
        if (aRole) {
            wItemsPref.push({ label: this.translate.instant('Menu_Ed') , icon: 'pi pi-pencil', routerLink: ['/editors'] });
            wItemsPref.push({ label: this.translate.instant('Menu_Delegate'), icon: "icons8-organigramme", routerLink: ['/delegate'] });
            wItemsPref.push({ label: this.translate.instant('Menu_J'), icon: "icons8-nouvelles", routerLink: ['/page-log-track'] });
        } else {
            if (this.editorUpdate === true) {
                wItemsPref.push({ label: this.translate.instant('Menu_Ed'), icon: 'pi pi-pencil', routerLink: ['/editors'] });                    
            }
            if (this.delegateEnable === true) {
                wItemsPref.push({ label: this.translate.instant('Menu_Delegate'), icon: "icons8-organigramme", routerLink: ['/delegate'] });
                wItemsPref.push({ label: this.translate.instant('Menu_J'), icon: "icons8-nouvelles", routerLink: ['/page-log-track'] });
            }
        }
        if (this.rightService.menuItem.TRBrs === true ||
            this.rightService.menuItem.TRBsk === true ||
            this.rightService.menuItem.TRTxt === true ||
            this.rightService.menuItem.TRVar === true) {
                wItemsPref.push({ label: this.translate.instant('Menu_Batch'), icon: "pi pi-stopwatch", routerLink: ['/page-batch'] });
        }

        if (this.rightService.menuItem.TPref) {
            wItemsPref.push({ label: this.translate.instant('Menu_Pref'), icon: "icons8-param-tres", routerLink: ['/preference'] });
        };
        if (wItemsPref.length !== 0) {
            wPrefMenu = [
                {
                    id: 'ToolMenu',
                    label: this.translate.instant('Menu_Params'),
                    icon: "icons8-entretien",
                    items: wItemsPref,
                    forceRoot: false,
                },
            ];
        }
        return wPrefMenu;
    }

    private getAdminMenu(aRole) {
        let wAdminMenu = [];
        if (aRole === true ) {
            wAdminMenu = this.getAdminMenuItem();
        }
        return wAdminMenu; 
    }

    private getAdminMenuItem() {
        let wItemsPref = [];
        let wItemsAssoc = [];
        let wItemsMenu = [];
        let wTrackLog = [];

        if (this.verifyCustMenu() === true) {
            wItemsMenu.push({ label: this.translate.instant('Menu_RS'), icon: "icons8-lock-screen", routerLink: ['/custrights'] });
            wItemsMenu.push({ label: this.translate.instant('Menu_AM'), icon: 'pi pi-fw pi-desktop', routerLink: ['/page-screenbsk'] });
            wItemsMenu.push({ label: this.translate.instant('Mg_CustMenu'), icon: 'pi pi-fw pi-bars', routerLink: ['/page-custmenubase'] });
        }
        wItemsAssoc.push({ label: this.translate.instant('Menu_AR'), icon: 'pi pi-fw pi-desktop', routerLink: ['/page-reqbsk'] });
        wItemsAssoc.push({ label: this.translate.instant('Menu_RB'), icon: 'pi pi-fw pi-desktop', routerLink: ['/page-resbsk'] });        
        wItemsAssoc.push({ label: this.translate.instant('Menu_AU'), icon: 'pi pi-fw pi-desktop', routerLink: ['/page-userbsk'] });
        wItemsAssoc.push({ label: this.translate.instant('Menu_AT'), icon: 'pi pi-fw pi-desktop', routerLink: ['/page-tagbsk'] });
                 
        wTrackLog.push({ label: this.translate.instant('Menu_CN'), icon: "icons8-connexion", routerLink: ['/page-last-connect'] });
        wTrackLog.push({ label: this.translate.instant('Menu_Mail'), icon: "pi pi-at", routerLink: ['/page-mail'] });
        wTrackLog.push({ label: this.translate.instant('Menu_LockDocs'), icon: "icons8-padlock-outline", routerLink: ['/page-lock-docs'] });
        wTrackLog.push({ label: this.translate.instant('Menu_DeleteDocs'), icon: "pi icons8-trash-can", routerLink: ['/page-delete-docs'] });
        wTrackLog.push({ label: this.translate.instant('Menu_ErrorLog'), icon: "pi pi-flag", routerLink: ['/page-logs'] });

        wItemsPref.push({ label: this.translate.instant('Menu_RE'), icon: "icons8-edit", routerLink: ['/editorrights'] });
        wItemsPref.push({ label: this.translate.instant('Menu_T'), icon: 'pi pi-fw pi-tags', routerLink: ['/page-tagbase'] });
        wItemsPref.push({ label: this.translate.instant('Menu_SU'), icon: 'pi pi-fw pi-tags', routerLink: ['/page-supervbase'] });
        wItemsPref.push({ label: this.translate.instant('Menu_ADL'), icon: 'pi pi-fw pi-user-plus', routerLink: ['/page-admindelegate'] });
        if (wItemsMenu.length !== 0) {
            wItemsPref.push({ label: this.translate.instant('Menu_Dock'), icon: "pi pi-id-card", items: wItemsMenu});
        }        
        wItemsPref.push({ label: this.translate.instant('Menu_Assoc'), icon: "pi pi-id-card", items: wItemsAssoc});
        wItemsPref.push({ label: this.translate.instant('Track_Log'), icon: "pi pi-id-card", items: wTrackLog});        
        wItemsPref.push({ label: this.translate.instant('Menu_C') , icon: "pi pi-cog", routerLink: ['/page-basket-param'] });
        wItemsPref.push({ label: this.translate.instant('Menu_Param_Docks_Pos'), icon: "icons8-param-tres", routerLink: ['/page-param-docks-pos'] });
        wItemsPref.push({ label: this.translate.instant('Menu_ImpExp'), icon: "icons8-param-tres", routerLink: ['/page-export'] });        
        wItemsPref.push({ label: this.translate.instant('Menu_Param'), icon: "icons8-param-tres", routerLink: ['/page-param'] });
        return [
            {
                id: 'ConfMenu',
                label: this.translate.instant('Menu_AD'),
                icon: "icons8-param-tres-administrateur-homme",
                items: wItemsPref,
                forceRoot: false,
            },
        ];     
    }

    public getAdminMenuElem(aRole: boolean) {
        let wItemsPref = [];
        let wRoles = {
            mgtUser: true,
            mgtGrp: true,
            mgtBsk: true,
            mgtGed: true,
            mgtDlgt: true,
        };
        if (aRole === true) {
            wItemsPref = [...this.setAdminMenu(wRoles)];
        } else {
            wItemsPref = [...this.getUserRoleMenuData()];
        }
        return wItemsPref;
    }

    private getUserRoleMenuData() {
        let wItemsPref = [];
        this._menuUserRole = false;
        if (this.userRoleMenuData.length !== 0 && this.userRoleMenuData[0].rightValues.length !== 0) {
            let wRoles = JSON.parse(this.userRoleMenuData[0].rightValues);
            wItemsPref = [...this.setAdminMenu(wRoles)];
        }
        if (wItemsPref.length !== 0) {
            this._menuUserRole = true;
        }
        return wItemsPref;
    }

    private setAdminMenu(aRoles) {
        let wItemsPref = [];
        if (aRoles.mgtUser === true) {
            wItemsPref.push({ label: this.translate.instant('Cf_Mg_User'), icon: 'pi pi-user-edit', routerLink: ['/page-cfg-user'] });
        }
        if (aRoles.mgtGrp === true) {
            wItemsPref.push({ label: this.translate.instant('Cf_Mg_Group'), icon: 'pi pi-users', routerLink: ['/page-cfg-group'] });
        }
        if (aRoles.mgtBsk === true) {
            wItemsPref.push({ label: this.translate.instant('Cf_Mg_Basket'), icon: 'icons8-bo-te-de-r-ception', routerLink: ['/page-cfg-basket'] });
        }
        if (aRoles.mgtGed === true) {
            wItemsPref.push({ label: this.translate.instant('Menu_Right'), icon: "icons8-organigramme", routerLink: ['/page-access-right'] });
        }
        if (aRoles.mgtDlgt === true) {
            wItemsPref.push({ label: this.translate.instant('Menu_RD'), icon: "icons8-accessibility-tools", routerLink: ['/delegaterights'] });
        }
        return wItemsPref;
    }

    private verifyCustMenu() {        
        return customizedScreenRoutes.length !== 0;

    }

    get menuVisible() {
        return this._menuVisible;
    }

    set menuVisible(aValue) {
        this._menuVisible = aValue;
    }

    get menuRestrict() {
        return this._menuRestrict;
    }

    set menuRestrict(aValue) {
        this._menuRestrict = aValue;
    }

    get menuUserRole() {
        return this._menuUserRole;
    }

    set menuUserRole(aValue) {
        this._menuUserRole = aValue;
    }

    private getAllowRequest() {
        return this.rightService.menuItem.TQMod;
    }

    private getAllowSearchIdx() {
        return this.rightService.menuItem.TRVar;
    }

    private getAllowSearchFullText() {
        return this.rightService.menuItem.TRTxt;
    }

    public displayMenu() {
        this.display = true;
    }

    public logout() {
        let wInternal: any;
        wInternal= localStorage.getItem('intern');
        if (wInternal) {
            wInternal = JSON.parse(atob(wInternal));
            this.items = [];
            this.menuMode = this.layoutService.config().menuMode;
            this.auth.logout();
            if (wInternal.discntAzure === 'true') {
                this.authService.logoutRedirect();
            }
        }
    }

    public fullText(aPage) {
        if (this.rightService.menuItem.TRTxt === false) {
            return defaultPage;
        } else {
            return aPage;
        }
    }

    public browse(aPage) {
        if (this.rightService.menuItem.TRBrs === false) {
            return defaultPage;
        } else {
            return aPage;
        }
    }

    public index(aPage) {
        if (this.rightService.menuItem.TRVar === false) {
            return defaultPage;
        } else {
            return aPage;
        }
    }

    public basket(aPage) {
        if (this.rightService.menuItem.TRBsk === false) {
            return defaultPage;
        } else {
            return aPage;
        }
    }
    
    changeTheme(theme) {
        const themeLink: HTMLLinkElement = <HTMLLinkElement>document.getElementById('theme-link');
        if (theme === '') {
            theme = this.layoutService.config().componentTheme;
        }
        if (this.currentTheme !== theme) {
            themeLink.href = 'assets/layout/styles/theme/theme-light/' + theme + '/theme.css';
            this.layoutService.config().componentTheme = theme;
            this.currentTheme = theme;
        }
    }

    public changeScale(aScale) {
        document.documentElement.style.fontSize = aScale + 'px';
    }

}
